export const ENV_VN = {
    mode: 'Production'
    , production: false
    , msalConfig: {
         auth: {
            clientId: '21248f50-2f61-44ae-b9c9-fd4bd17ccad0'
            , authority: 'https://login.microsoftonline.com/ae7498ce-d4a7-47cf-b9f9-380629597a47'
            , tenantId: 'ae7498ce-d4a7-47cf-b9f9-380629597a47'
        }
    }
    , apiConfig: {
        scopes: ['https://ConnectClient.onmicrosoft.com/21248f50-2f61-44ae-b9c9-fd4bd17ccad0/eos.api.access']
        , uri: '/api/*'
        , postLogoutRedirectUri: 'https://easyorder.vnbizbox.com'
        , redirectUri: 'https://easyorder.vnbizbox.com'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'https://easyorder.vnbizbox.com/#/unauthorized'
        , unauthorizedRedirect: 'https://easyorder.vnbizbox.com'
    }
    , redirectConfig: {
        connectPlusUrl: 'https://clm.euris.com/dksh-hc/'
        , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
    }
  }


// WEBPACK FOOTER //
// ./src/environment/environment.vn.ts